import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import AdvancedDropdown from '@xanadu/ui-shared/components/widgets/AdvancedDropdown';

import styles from './DropdownField.module.scss';

const DropdownField = ({
  id,
  className = '',
  textAlign = 'left',
  alignOptions = 'left',
  dataHook = '',
  fluid = false,
  name,
  label = '',
  theme,
  onPropertyChange,
  value,
  items,
  error = '',
  inline,
  isPhoneNumber = false,
  placeholder = 'Select',
  fullWidth = false
}) => {
  const onDropdownChange = (data) => {
    onPropertyChange({ name, value: data });
  };

  const mainClass = cn({
    [styles.main]: true,
    [styles['main--inline']]: inline,
    [className]: true,
  });

  const errorClass = error ? styles['dropdown--error'] : '';
  const inputError = !!error && (
    <div className={styles.containerMessages}>
      <span className={styles.errorMessage} data-hook={`${dataHook}-error`}>
        {error}
      </span>
    </div>
  );

  return (
    <div className={mainClass}>
      <div className={styles.property}>
        <label htmlFor={id} className={styles.label}>{label}</label>
        <AdvancedDropdown
          selectedItem={value}
          theme={theme}
          placeholder={placeholder}
          onChange={onDropdownChange}
          className={errorClass}
          items={items}
          dataHook={dataHook}
          fluid={fluid}
          autoComplete="off"
          useNewVersion
          fullWidth={fullWidth}
          textAlign={textAlign}
          alignOptions={alignOptions}
          isPhoneNumber={isPhoneNumber}
        />
      </div>
      {inputError}
    </div>
  );
};

DropdownField.propTypes = {
  id: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  textAlign: PropTypes.oneOf(['left', 'right']),
  alignOptions: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  dataHook: PropTypes.string,
  fluid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onPropertyChange: PropTypes.func,
  items: PropTypes.instanceOf(Array),
  value: PropTypes.any.isRequired,
  fullWidth: PropTypes.bool,
  isPhoneNumber: PropTypes.bool,
  error: PropTypes.string,
  inline: PropTypes.bool,
};

export default DropdownField;
